import { useMemo } from 'react';
import { VehicleOption } from '@mark43/cad-api';

export function useFilteredMultiVehiclesOptionsInDisplayedFormat({
    multiVehiclesOptions,
    currentTowVehicleTitle,
    currentTowVehicleVinNumber,
}: {
    multiVehiclesOptions: VehicleOption[];
    currentTowVehicleTitle?: string | null;
    currentTowVehicleVinNumber?: string | null;
}) {
    return useMemo(() => {
        let currentTowVehicleIndex: number = Infinity;

        return multiVehiclesOptions
            .filter((option, index) => {
                const arePlateNumbersEqual = option.tag === currentTowVehicleTitle;
                const areVinNumbersEqual =
                    !!option?.vinNumber && option?.vinNumber === currentTowVehicleVinNumber;
                const isCurrentTowVehicle = arePlateNumbersEqual || areVinNumbersEqual;

                if (isCurrentTowVehicle) {
                    currentTowVehicleIndex = index;
                }

                return !isCurrentTowVehicle;
            })
            .map((option, index) => {
                const optionIndex = index < currentTowVehicleIndex ? index : index + 1;

                return {
                    value: optionIndex,
                    label: option?.tag ?? `Vehicle ${optionIndex + 1}`,
                };
            });
    }, [multiVehiclesOptions, currentTowVehicleTitle, currentTowVehicleVinNumber]);
}
